<script setup>
defineProps({ data: { type: Object, required: true } });
</script>

<template>
  <section class="section">
    <div class="container-x grid gap-8 lg:gap-10 lg:grid-cols-2">
      <div>
        <BlockRenderer :blocks="data.left" />
      </div>
      <div>
        <BlockRenderer :blocks="data.right" />
      </div>
    </div>
  </section>
</template>
